import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHFormWrapper from "../../components/TMHForm/TMHFormWrapper"
import TMHFormBase from "../../components/TMHForm/TMHFormBase"
import TMHMemberPin from "../../components/TMHForm/TMHMemberPin"
import Separator from "../../components/Separator/Separator"
import "./CongratulationPage.css"
import useAuth from "../../core/Authentication/useAuth"
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"

export default function CongratulationPage() {
  useTitle("Congratulations - The Movie House TV")

  const auth = useAuth()
  const navigate = useNavigate()
  const [emailAddress, setEmailAddress] = useState("")
  const [pinNumber, setPinNumber] = useState("")

  useEffect(() => {
    if (auth.isLogged()) {
      ReactGA.send("pageview")
      setEmailAddress(auth.user?.username)
      setPinNumber(auth.user?.pin)
    }
    else {
      navigate("/login")
    }

  }, [setEmailAddress, auth, navigate])

  return (
    <TMHBanner isLogged={false}>
      <TMHFormWrapper>
        <TMHFormBase>
          <div className="congratulation-page-title">Congratulations!</div>
          <div className="congratulation-page-member-text">You are now a member of The Movie House!</div>
          <Separator />
          <div className="congratulation-page-pin-text">Your member pin is</div>
          <TMHMemberPin className="congratulation-page-pin-number" pinNumber={pinNumber} />
          <div className="congratulation-page-email-enable-text">It has also been emailed to {emailAddress}. If this email is not correct re-register with your correct email to get a new code.</div>
          <div className="congratulation-page-detail-text">To watch free new release movies you must install The Movie House app on your Roku device that is connected to your TV. After installing the app you will use the pin provided to link your account and receive new release movies.</div>
          <div className="congratulation-page-detail-text">There are 2 options for how to install The Movie House on your Roku.</div>
          <div className="congratulation-page-detail-text">1. Install The Movie House directly on my Roku device that is connected to my TV.</div>
          <a href="/tmh/#/install-direct" target="_blank" className="congratulation-page-install-button">Install direct on my Roku Device</a>
          <div className="congratulation-page-detail-text">2. Install The Movie House by going to Roku.com and adding it to your account which will then appear on your Roku app list.</div>
          <a href="/tmh/#/visit-roku-website" target="_blank" className="congratulation-page-install-button" style={{ marginBottom: "20px" }}>Install using my account on Roku.com</a>
        </TMHFormBase>
      </TMHFormWrapper>
    </TMHBanner>
  )
}